import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { map } from 'rxjs/operators';

export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // No token at all → straight to login.
  if (!auth.hasToken()) return router.createUrlTree(['/login']);

  // Session already hydrated: decide synchronously.
  if (auth.currentUser()) {
    return auth.isSuperAdmin() ? true : router.createUrlTree(['/']);
  }

  // On a hard refresh the user signal is still null because the session is
  // restored asynchronously. Bailing to /login here loses the requested URL:
  // guestGuard then sends the super-admin to /platform/dashboard. Wait for the
  // session to load before deciding, mirroring authGuard.
  return auth.ensureSession().pipe(
    map((user) => {
      if (!user) return router.createUrlTree(['/login']);
      return user.platformRole === 'super_admin'
        ? true
        : router.createUrlTree(['/']);
    }),
  );
};
